const kenkoLoader = {
  assets: [
    {
      id: '4',
      layers: [
        {
          ind: 3,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '8',
      layers: [
        {
          ind: 7,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '22',
      layers: [
        {
          ind: 21,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '27',
      layers: [
        {
          ind: 26,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '31',
      layers: [
        {
          ind: 30,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '35',
      layers: [
        {
          ind: 34,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [16, 6]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [32, 12]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0.051, 0.58, 0.533]
              },
              o: {
                a: 0,
                k: 100
              }
            }
          ]
        }
      ]
    },
    {
      id: '38',
      layers: [
        {
          ind: 29,
          ty: 0,
          parent: 25,
          ks: {
            a: {
              a: 0,
              k: [16, 6]
            },
            o: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [100],
                  h: 1
                },
                {
                  t: 189.12,
                  s: [100],
                  h: 1
                },
                {
                  t: 189.12,
                  s: [0],
                  h: 1
                },
                {
                  t: 204.12,
                  s: [0],
                  h: 1
                },
                {
                  t: 204.12,
                  s: [100],
                  h: 1
                },
                {
                  t: 211.8,
                  s: [100],
                  h: 1
                }
              ]
            },
            p: {
              a: 0,
              k: [32, 16]
            },
            r: {
              a: 0,
              k: 90
            }
          },
          w: 32,
          h: 12,
          ip: 0,
          op: 212.8,
          st: 0,
          refId: '27'
        },
        {
          ind: 33,
          ty: 0,
          parent: 25,
          ks: {
            a: {
              a: 0,
              k: [16, 6]
            },
            o: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [100],
                  h: 1
                },
                {
                  t: 50.7,
                  s: [100],
                  h: 1
                },
                {
                  t: 50.7,
                  s: [0],
                  h: 1
                },
                {
                  t: 196.62,
                  s: [0],
                  h: 1
                },
                {
                  t: 196.62,
                  s: [100],
                  h: 1
                },
                {
                  t: 211.8,
                  s: [100],
                  h: 1
                }
              ]
            },
            p: {
              a: 0,
              k: [43.444, 20.686]
            },
            r: {
              a: 0,
              k: 135
            }
          },
          w: 32,
          h: 12,
          ip: 0,
          op: 212.8,
          st: 0,
          refId: '31'
        },
        {
          ind: 37,
          ty: 0,
          parent: 25,
          ks: {
            o: {
              a: 1,
              k: [
                {
                  t: 0,
                  s: [100],
                  h: 1
                },
                {
                  t: 43.2,
                  s: [100],
                  h: 1
                },
                {
                  t: 43.2,
                  s: [0],
                  h: 1
                },
                {
                  t: 189.12,
                  s: [0],
                  h: 1
                },
                {
                  t: 189.12,
                  s: [100],
                  h: 1
                },
                {
                  t: 211.8,
                  s: [100],
                  h: 1
                }
              ]
            },
            p: {
              a: 0,
              k: [32, 26]
            }
          },
          w: 32,
          h: 12,
          ip: 0,
          op: 212.8,
          st: 0,
          refId: '35'
        },
        {
          ind: 25,
          ty: 3,
          ks: {
            p: {
              a: 0,
              k: [0, 1]
            }
          },
          ip: 0,
          op: 212.8,
          st: 0
        }
      ]
    },
    {
      id: '42',
      layers: [
        {
          ind: 41,
          ty: 4,
          ks: {},
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'rc',
              p: {
                a: 0,
                k: [19, 19]
              },
              r: {
                a: 0,
                k: 0
              },
              s: {
                a: 0,
                k: [38, 38]
              }
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [0, 0, 0, 0]
              },
              o: {
                a: 0,
                k: 0
              }
            }
          ]
        },
        {
          ind: 0,
          ty: 4,
          ks: {
            s: {
              a: 0,
              k: [133.33, 133.33]
            }
          },
          ip: 0,
          op: 212.8,
          st: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ty: 'gr',
                  it: [
                    {
                      ty: 'sh',
                      ks: {
                        a: 0,
                        k: {
                          c: true,
                          i: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          o: [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          v: [
                            [28.5, 28.5],
                            [20.36, 20.14],
                            [20.36, 8.36],
                            [8.14, 8.36],
                            [0, 0],
                            [28.5, 0]
                          ]
                        }
                      }
                    },
                    {
                      ty: 'fl',
                      c: {
                        a: 0,
                        k: [0.05, 0.58, 0.53, 1]
                      },
                      o: {
                        a: 0,
                        k: 100
                      }
                    },
                    {
                      ty: 'tr',
                      o: {
                        a: 0,
                        k: 100
                      }
                    }
                  ]
                },
                {
                  ty: 'tr',
                  o: {
                    a: 0,
                    k: 100
                  }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '45',
      layers: [
        {
          ind: 44,
          ty: 0,
          ks: {},
          w: 38,
          h: 38,
          ip: 0,
          op: 212.8,
          st: 0,
          refId: '42'
        }
      ]
    }
  ],
  fr: 60,
  h: 128,
  ip: 0,
  layers: [
    {
      ind: 6,
      ty: 0,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        o: {
          a: 1,
          k: [
            {
              t: 0,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [100],
              h: 1
            },
            {
              t: 211.8,
              s: [100],
              h: 1
            }
          ]
        },
        p: {
          a: 0,
          k: [32, 16]
        },
        r: {
          a: 0,
          k: 90
        }
      },
      w: 32,
      h: 12,
      ip: 0,
      op: 212.8,
      st: 0,
      refId: '4'
    },
    {
      ind: 10,
      ty: 0,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        o: {
          a: 1,
          k: [
            {
              t: 0,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [100],
              h: 1
            },
            {
              t: 211.8,
              s: [100],
              h: 1
            }
          ]
        },
        p: {
          a: 0,
          k: [43.444, 20.686]
        },
        r: {
          a: 0,
          k: 135
        }
      },
      w: 32,
      h: 12,
      ip: 0,
      op: 212.8,
      st: 0,
      refId: '8'
    },
    {
      ind: 12,
      ty: 4,
      parent: 11,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0,
      shapes: [
        {
          ty: 'rc',
          p: {
            a: 0,
            k: [16, 6]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [32, 12]
          }
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.051, 0.58, 0.533]
          },
          o: {
            a: 0,
            k: 100
          }
        }
      ]
    },
    {
      ind: 11,
      ty: 3,
      parent: 2,
      ks: {
        p: {
          a: 0,
          k: [32, 26]
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 14,
      ty: 4,
      parent: 13,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0,
      shapes: [
        {
          ty: 'rc',
          p: {
            a: 0,
            k: [16, 6]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [32, 12]
          }
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.051, 0.58, 0.533]
          },
          o: {
            a: 0,
            k: 100
          }
        }
      ]
    },
    {
      ind: 13,
      ty: 3,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        p: {
          a: 0,
          k: [43.444, 43.314]
        },
        r: {
          a: 0,
          k: -135
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 16,
      ty: 4,
      parent: 15,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0,
      shapes: [
        {
          ty: 'rc',
          p: {
            a: 0,
            k: [16, 6]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [32, 12]
          }
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.051, 0.58, 0.533]
          },
          o: {
            a: 0,
            k: 100
          }
        }
      ]
    },
    {
      ind: 15,
      ty: 3,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        p: {
          a: 0,
          k: [32, 48]
        },
        r: {
          a: 0,
          k: 90
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 18,
      ty: 4,
      parent: 17,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0,
      shapes: [
        {
          ty: 'rc',
          p: {
            a: 0,
            k: [16, 6]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [32, 12]
          }
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.051, 0.58, 0.533]
          },
          o: {
            a: 0,
            k: 100
          }
        }
      ]
    },
    {
      ind: 17,
      ty: 3,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        p: {
          a: 0,
          k: [20.816, 43.314]
        },
        r: {
          a: 0,
          k: 135
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 20,
      ty: 4,
      parent: 19,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0,
      shapes: [
        {
          ty: 'rc',
          p: {
            a: 0,
            k: [16, 6]
          },
          r: {
            a: 0,
            k: 0
          },
          s: {
            a: 0,
            k: [32, 12]
          }
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0.051, 0.58, 0.533]
          },
          o: {
            a: 0,
            k: 100
          }
        }
      ]
    },
    {
      ind: 19,
      ty: 3,
      parent: 2,
      ks: {
        p: {
          a: 0,
          k: [0, 26]
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 24,
      ty: 0,
      parent: 2,
      ks: {
        a: {
          a: 0,
          k: [16, 6]
        },
        o: {
          a: 1,
          k: [
            {
              t: 0,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [100],
              h: 1
            },
            {
              t: 37.5,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [0],
              h: 1
            },
            {
              t: 211.62,
              s: [100],
              h: 1
            },
            {
              t: 211.8,
              s: [100],
              h: 1
            }
          ]
        },
        p: {
          a: 0,
          k: [20.816, 20.686]
        },
        r: {
          a: 0,
          k: -135
        }
      },
      w: 32,
      h: 12,
      ip: 0,
      op: 212.8,
      st: 0,
      refId: '22'
    },
    {
      ind: 2,
      ty: 3,
      parent: 1,
      ks: {
        a: {
          a: 0,
          k: [32, 32]
        },
        p: {
          a: 0,
          k: [64, 64]
        },
        r: {
          a: 1,
          k: [
            {
              t: 0,
              s: [180],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 30,
              s: [360],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 37.5,
              s: [405],
              h: 1
            },
            {
              t: 211.8,
              s: [405],
              h: 1
            }
          ]
        }
      },
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 40,
      ty: 0,
      parent: 1,
      ks: {
        a: {
          a: 0,
          k: [32, 33]
        },
        o: {
          a: 1,
          k: [
            {
              t: 0,
              s: [0],
              h: 1
            },
            {
              t: 37.5,
              s: [0],
              h: 1
            },
            {
              t: 37.5,
              s: [100],
              h: 1
            },
            {
              t: 211.62,
              s: [100],
              h: 1
            },
            {
              t: 211.62,
              s: [0],
              h: 1
            },
            {
              t: 211.8,
              s: [0],
              h: 1
            }
          ]
        },
        p: {
          a: 0,
          k: [64, 64]
        },
        r: {
          a: 1,
          k: [
            {
              t: 0,
              s: [0],
              h: 1
            },
            {
              t: 35.7,
              s: [0],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 43.2,
              s: [45],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 50.7,
              s: [90],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 58.2,
              s: [135],
              h: 1
            },
            {
              t: 189.06,
              s: [135],
              i: {
                x: 0,
                y: 1
              },
              o: {
                x: 0.5,
                y: 0
              }
            },
            {
              t: 189.12,
              s: [225],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 196.62,
              s: [270],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 204.12,
              s: [315],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 211.62,
              s: [360],
              h: 1
            },
            {
              t: 211.8,
              s: [360],
              h: 1
            }
          ]
        }
      },
      w: 64,
      h: 39,
      ip: 0,
      op: 212.8,
      st: 0,
      refId: '38'
    },
    {
      ind: 47,
      ty: 0,
      parent: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              t: 0,
              s: [0],
              h: 1
            },
            {
              t: 68.82,
              s: [0],
              i: {
                x: 0,
                y: 1
              },
              o: {
                x: 0,
                y: 0
              }
            },
            {
              t: 113.82,
              s: [100],
              h: 1
            },
            {
              t: 134.82,
              s: [100],
              i: {
                x: 1,
                y: 1
              },
              o: {
                x: 1,
                y: 0
              }
            },
            {
              t: 179.82,
              s: [0],
              h: 1
            },
            {
              t: 211.8,
              s: [0],
              h: 1
            }
          ]
        },
        p: {
          a: 1,
          k: [
            {
              t: 0,
              s: [32, 58],
              i: {
                x: [1, 1],
                y: [1, 1]
              },
              o: {
                x: [0, 0],
                y: [0, 0]
              }
            },
            {
              t: 68.82,
              s: [32, 58],
              i: {
                x: [0, 0],
                y: [1, 1]
              },
              o: {
                x: [0, 0],
                y: [0, 0]
              }
            },
            {
              t: 113.82,
              s: [56, 34],
              i: {
                x: [1, 1],
                y: [1, 1]
              },
              o: {
                x: [0, 0],
                y: [0, 0]
              }
            },
            {
              t: 134.82,
              s: [56, 34],
              i: {
                x: [1, 1],
                y: [1, 1]
              },
              o: {
                x: [1, 1],
                y: [0, 0]
              }
            },
            {
              t: 179.82,
              s: [80, 10],
              i: {
                x: [1, 1],
                y: [1, 1]
              },
              o: {
                x: [0, 0],
                y: [0, 0]
              }
            },
            {
              t: 211.8,
              s: [80, 10],
              h: 1
            }
          ]
        }
      },
      w: 38,
      h: 38,
      ip: 0,
      op: 212.8,
      st: 0,
      refId: '45'
    },
    {
      ind: 1,
      ty: 3,
      parent: 0,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0
    },
    {
      ind: 0,
      ty: 3,
      ks: {},
      ip: 0,
      op: 212.8,
      st: 0
    }
  ],
  meta: {
    g: 'https://jitter.video'
  },
  op: 211.8,
  v: '5.7.4',
  w: 128
}

export default kenkoLoader
